export default __webpack_public_path__ + "static/media/1W_course.ddcb6167.png";